"use client";

import { useTranslations } from "next-intl";
import { useConsumerLocale } from "@/app/i18n/ConsumerIntlProvider";
import { TermsPageView } from "@/components/terms/TermsPageView";
import type { ParsedTerms } from "@/content/parseConsumerTerms";

/**
 * Renders legal terms with locale-aware chrome around build-time Spanish content.
 */
export function TermsPageClient({ data }: { data: ParsedTerms }) {
  const t = useTranslations("terms");
  const { locale } = useConsumerLocale();
  return (
    <TermsPageView
      title={t("title")}
      subtitle={t("subtitle")}
      backLabel={t("backToEvents")}
      languageNote={locale === "en" ? t("languageNote") : null}
      introParagraphs={data.introParagraphs}
      sections={data.sections}
    />
  );
}
